import React, {useState} from 'react';
import clsx from 'clsx';
import AdminOrdersView from './AdminOrdersView';
import AdminOrderDetailView from './AdminOrderDetailView';
import AdminSubscriptionsView from './AdminSubscriptionsView';
import AdminMembershipsView from './AdminMembershipsView';

/**
 * Orders console embedded in the super-admin shell (AdminView). Keeps the
 * left menu + breadcrumb (unlike the standalone /admin/orders routes) by
 * managing list ↔ detail and the Orders/Subscriptions/Memberships tabs as
 * local state instead of routing away. The child views fall back to
 * routing when used standalone (deep links), so both entry points keep
 * working.
 */
type Tab = 'orders' | 'subscriptions' | 'memberships';

const AdminOrdersSection: React.FC = () => {
    const [tab, setTab] = useState<Tab>('orders');
    const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);

    if (selectedOrderId) {
        return <AdminOrderDetailView orderId={selectedOrderId} onBack={() => setSelectedOrderId(null)} />;
    }

    return (
        <div>
            <div className="flex gap-1 px-6 pt-4">
                {(['orders', 'subscriptions', 'memberships'] as Tab[]).map((t) => (
                    <button
                        key={t}
                        type="button"
                        onClick={() => setTab(t)}
                        className={clsx(
                            'rounded-[7px] px-3 py-1.5 text-xs font-semibold transition',
                            tab === t
                                ? 'bg-mld-primary/10 text-mld-primary'
                                : 'text-mld-muted-text hover:bg-mld-background hover:text-mld-menu-text'
                        )}>
                        {t === 'orders' ? 'Orders' : t === 'subscriptions' ? 'Subscriptions' : 'Memberships'}
                    </button>
                ))}
            </div>
            {tab === 'orders' && <AdminOrdersView onSelectOrder={setSelectedOrderId} />}
            {tab === 'subscriptions' && <AdminSubscriptionsView />}
            {tab === 'memberships' && <AdminMembershipsView />}
        </div>
    );
};

export default AdminOrdersSection;
